import type { MarketTemplate, SubMarketGroupType } from '@ps/isp-web-services-types';

import type { ClientMarketGroup } from '../../../../../model/types';

interface Props {
  currentGroup: ClientMarketGroup;
  templates: MarketTemplate[];
  selectedSubMarketGroupType: SubMarketGroupType | undefined;
}

export const getSelectedSubMarketGroupTypeTemplates = ({
  currentGroup,
  templates,
  selectedSubMarketGroupType
}: Props) =>
  currentGroup.groupedTemplates?.flat().find((group) => group.type === selectedSubMarketGroupType)
    ?.templates ?? templates;
